module.exports = __webpack_public_path__ + "img/doe-logo-white.89f17b06.svg";